<style type="text/css">
    
.img-logo {
    margin: auto!important;
    width: 200px;
    display: block;
    padding-top: 20px;
}

</style>

<template>
    <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
            <div class="card bg-secondary shadow border-0">

<img class="img-logo" src="img/brand/justwash.png"/>

                <!-- <div class="card-header bg-transparent pb-5">
                    <div class="text-muted text-center mt-2 mb-3"><small>Sign in with</small></div>
                    <div class="btn-wrapper text-center">
                        <a href="#" class="btn btn-neutral btn-icon">
                            <span class="btn-inner--icon"><img src="img/icons/common/github.svg"></span>
                            <span class="btn-inner--text">Github</span>
                        </a>
                        <a href="#" class="btn btn-neutral btn-icon">
                            <span class="btn-inner--icon"><img src="img/icons/common/google.svg"></span>
                            <span class="btn-inner--text">Google</span>
                        </a>
                    </div>
                </div> -->
                <div class="card-body px-lg-5 py-lg-5">
                    <div class="text-center text-muted mb-4">
                        <span>Login to your Account</span>
                    </div>
                    <form role="form"> <!-- v-on:submit="login" -->
                       
                        <base-input class="input-group-alternative mb-3"
                                    placeholder="Username"
                                    addon-left-icon="ni ni-single-02"
                                    v-model="model.username" v-on:keyup.enter="login">
                        </base-input>

                        <!-- <div class="col-md-6">
                            <base-input placeholder="Success" :valid="true"></base-input>
                        </div>
                        <div class="col-md-6">
                            <base-input placeholder="Error input" :valid="false"></base-input>
                        </div> -->

                        <base-input class="input-group-alternative"
                                    placeholder="Password"
                                    type="password"
                                    addon-left-icon="ni ni-lock-circle-open"
                                    v-model="model.password" v-on:keyup.enter="login">
                        </base-input>

                    <!--     <base-checkbox class="custom-control-alternative">
                            <span class="text-muted">Remember me</span>
                        </base-checkbox> -->
                        <div class="text-center">
                            <base-button type="primary" class="my-2" style="width: 100%; background-color:#007bff;" v-on:click="login">Login</base-button>
                            <!-- <button type="submit" name="button">เข้าสู่ระบบ</button> -->
                        </div>
                    </form>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12" style="text-align:center">
                    <a href='/#/remember' class="text-light"><small>Forgot Password?</small></a>
                </div>
                <!-- <div class="col-6 text-right">
                    <router-link to="/register" class="text-light"><small>สร้างบัญชีใหม่</small></router-link>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
  import JwService from '../service/justwash';


  export default {
    name: 'login',
    data() {
      return {
        model: {
          username: '',
          password: ''
        }
      }
    },
    mounted:{
        
    },
    methods: {
      login:function() {
        // console.log('login success');
        axios({
          method: 'post',
          url: JwService.getAPI()+'/api/method/justwash.OwnerApi.authen',
          data: {
            username: this.model.username,
            password: this.model.password
            // username: 'pimpran',
            // password: 'jwpimpran'
            // username: 'justwash',
            // password: 'w13n99to'
          }
        }).then((response) => {
          if (response.data.message.status == true) {
            this.loginData = response.data.message.data;
            // for (let idx in  response.data.message.data) {
            //   console.log(idx)
            // }
            // console.log(this.loginData);
            // console.log(response.data.message.data);
            // console.log('Login Success!!');
            // console.log(response.data.message.data.token);
            localStorage.setItem('accessToken', response.data.message.data.token);
            localStorage.setItem('customerName', response.data.message.data.customer_name)
            // console.log(localStorage);
            // localStorage.clear();
            this.$router.push('/');
          } else {
            alert('กรอกข้อมูลไม่ถูกต้อง');
            this.$router.push('/login')
            // console.log('Login Fail!!');
          }
        }).catch(error => {
          console.log(error)
          this.$router.push('/login')
        });
      }
    }
  }
</script>
<style>
</style>
